@if (routeNetwork.isLoading()) {
  <p>{{ 'General.LoadingOoo' | translate }}</p>
}

@if (routeNetwork.error()) {
  <p>Error loading route</p>
}

@if (routeNetwork.value() && routeNetwork.value(); as routeNetwork) {
  <div class="route-network-detail">
    <header class="route-network-detail__header">
      <div class="route-network-detail__header-top">
        <div class="route-network-detail__header--name">
          {{ routeNetwork.Name }}
        </div>

        <button class="route-network-detail__favorite-btn" (click)="toggleFavorite()" type="button">
          <span class="material-icons" [class.filled]="isFavorite()">
            {{ isFavorite() ? 'favorite' : 'favorite_border' }}
          </span>
        </button>
      </div>

      <div class="route-network-detail__meta">
        <div>{{ routeNetwork.CountyName }}</div>
        @if (routeNetwork.CountyName && routeNetwork.Association) {
          <span class="dot">•</span>
        }
        <div>{{ routeNetwork.Association }}</div>
      </div>

      @if (trailChips().length) {
        <div class="route-network-detail__chips">
          @for (chip of trailChips(); track chip.key) {
            <dv-button
              [isRound]="true"
              [color]="routeHighlightService.isActive(chip.filter) ? 'secondary' : 'default'"
              (click)="routeHighlightService.toggle(chip.filter)"
            >
              {{ chip.key | translate }}
            </dv-button>
          }
        </div>
      }
    </header>
    <dv-divider direction="horizontal"></dv-divider>
    <app-route-status
      [lastGroomedTime]="routeNetwork.LastMaintainedTimeUTC"
      [length]="routeNetwork.Length"
      [customerId]="routeNetwork.CustomerID"
      [maintainerTypeId]="routeNetwork.RouteNetworkMaintainerTypeID"
      [maintainerTypeTranslationKey]="routeNetwork.RouteNetworkMaintainerType_TranslationKey"
    ></app-route-status>

    @if (routeNetwork.VippsEnabled) {
      <dv-divider direction="horizontal"></dv-divider>
      <app-vipps
        [status]="vippsPaymentStatus()"
        (donate)="donate($event)"
        (cancelDonation)="cancelDonation()"
      />
    }

    @if (routeNetwork.Latitude && routeNetwork.Longitude) {
      <dv-divider direction="horizontal"></dv-divider>
      <app-weather
        [lat]="routeNetwork.Latitude"
        [lng]="routeNetwork.Longitude"
        [routeNetworkId]="routeNetwork.RouteNetworkID!"
      ></app-weather>
    }

    @if (routeNetwork.Description; as description) {
      <dv-divider direction="horizontal"></dv-divider>
      <div class="route-network-detail__description">
        <div class="route-network-detail__description--title">
          {{ 'RouteNetworkDetail.Description' | translate }}
        </div>
        <div class="route-network-detail__description--value" [innerHTML]="description"></div>
      </div>
    }
  </div>
}
